export const Ciastka = [

  {
    "id": "mieszanka-4",
    "name": "Uniwersalna mieszanka mąk bezglutenowych",
    "category": "BABECZKI",
    "shortDesc": "Idealna do zastąpienia mąki pszennej w wypiekach",
    "fullDesc": "Idealna do wszelkich wypieków, ta mieszanka mąk bezglutenowych łączy w sobie neutralność mąki jaglanej, orzechowy posmak mąki gryczanej oraz zbożowy akcent mąki amarantusowej. Ważne są proporcje, które należy zachować, aby uzyskać właściwości mąk zawierających gluten. Świetnie sprawdza się jako zamiennik mąki pszennej, zachowując odpowiednią konsystencję i sprężystość w wypiekach.",
  
    "preparation": "Na 9 szklanek mieszanki \n(należy zachować proporcje pierwszych sześciu szklanek do pozostałych trzech szklanek mąki ziemniaczanej i tapioki):\n\n6 szklanek mąki (w dowolnej proporcji): jaglanej, gryczanej, z amarantusa (ewentualnie mąka ryżowa lub kukurydziana)\n2 szklanki mąki (w dowolnej proporcji) ziemniaczanej lub z tapioki\n\n\nPrzykład:\n3 szklanki mąki jaglanej\n2 szklanki mąki gryczanej\n1 szklanka mąki z amarantusa\n2 szklanki mąki ziemniaczanej\n1 szklanka mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n2 szklanki mąki gryczanej\n1 szklanka mąki z amarantusa\n3 szklanki mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n3 szklanki mąki gryczanej\n3 szklanki mąki z tapioki\n\nLUB\n3 szklanki mąki jaglanej\n3 szklanki mąki gryczanej\n3 szklanki mąki ziemniaczanej\n\nLUB najprościej\n6 szklanek mąki jaglanej\n3 szklanki mąki ziemniaczanej\n\nLUB moja ulubiona wersja\n1kg mąki jaglanej\n1kg mąki gryczanej\n1kg mąki z tapioki\n\n Wymieszać razem, najlepiej przesiewając stopniowo przez sito.\nUprzednie przesianie i wymieszanie mąk na sucho zapewnia lepszą strukturę ciasta, zapobiega grudkom i poprawia wyrastanie.\n\n\nZdrowego! 🌱✨💚",
    "ingredients": [
        "Proporcje są kluczowe – sprawdź opis przygotowania, aby poznać dokładne ilości:\n",
        "Mąka jaglana",
        "Opcjonalnie: mąka gryczana (i mąka z amarantusa)",
        "Ewentualnie: mąka ryżowa lub kukurydziana",
        "Mąki ziemniaczana",
        "Opcjonalnie: mąka z tapioki"
    ].join("\n"),
    "image": "Babeczki/mieszanka.jpg",
    "path": "babeczki"
},
  

  {
    "id": "ciastko-1",
    "name": "Ciasteczka owsiane",
    "category": "CIASTKA",
    "shortDesc": "Pyszne ciasteczka z różnymi dodatkami",
    "fullDesc": "Ciasteczka owsiane, które łączą zdrowe składniki i pyszne dodatki takie jak orzechy, suszone owoce i nasiona. Idealne na każdą porę dnia. Przepis inspirowany przez Niebo na Talerzu.",
    "image": "Ciastka/ciasteczka_owsiane.jpg",
    "Preparation":"1. Przygotowanie ciasta:\n W misce połącz płatki owsiane, mąkę, jajka, ksylitol, roztopione masło i proszek do pieczenia. Jeśli masa jest zbyt gęsta, dodaj kilka łyżek mleka lub wody, aby uzyskać odpowiednią konsystencję.\n\n2. Rozgrzanie piekarnika:\n Nastaw piekarnik na 170°C z termoobiegiem.\n\n3. Formowanie ciasteczek:\nWilgotnymi rękami uformuj ciasteczka o wielkości spłaszczonego orzecha włoskiego. Posyp każde ciastko gruboziarnistym cukrem.\n\n4. Pieczenie:\nPiecz ciasteczka przez około 10-15 minut, aż lekko się zezłocą.\n\n5. Chłodzenie i podanie:\nPozwól ciastkom chwilę ostygnąć, a następnie podawaj i ciesz się ich smakiem!\n\n\nZdrowego! 🌱✨💚",

      "ingredients": [
        "2 szklanki płatków owsianych",
        "1 i ½ szklanki mąki owsianej bezglutenowej",
        "2 jajka",
        "Około ½ szklanki ksylitolu",
        "100 g roztopionego masła klarowanego lub oleju kokosowego",
        "½ łyżeczki proszku do pieczenia",
        "Szczypta soli himalajskiej lub kłodawskiej",
        "200 g dodatków (np. rodzynki, posiekane orzechy, żurawina, migdały, słonecznik, pestki dyni, sezam, siemię lniane, chia, miechunka, jagody goji, jagody acai)",
        "Gruby cukier trzcinowy, do posypania ciastek"
    ].join("\n"),
    "path": "ciastka"
}

,

{
  "id": "ciastko-2",
  "name": "Pierniki bezglutenowe",
  "category": "CIASTKA",
  "shortDesc": "Idealne na święta!",
  "fullDesc": "Pierniki bezglutenowe to doskonały wybór na świąteczne wypieki.",
  "image": "Ciastka/pierniki_bezglutenowe.jpg",
  "preparation": "1. Przygotowanie ciasta:\n W misce połącz płatki owsiane, mąkę, jajka, ksylitol, roztopione masło i proszek do pieczenia. Jeśli masa jest zbyt gęsta, dodaj kilka łyżek mleka lub wody, aby uzyskać odpowiednią konsystencję.\n\n2. Rozgrzanie piekarnika:\n Nastaw piekarnik na 170°C z termoobiegiem.\n\n3. Formowanie ciasteczek:\nWilgotnymi rękami uformuj ciasteczka o wielkości spłaszczonego orzecha włoskiego. Posyp każde ciastko gruboziarnistym cukrem.\n\n4. Pieczenie:\nPiecz ciasteczka przez około 10-15 minut, aż lekko się zezłocą.\n\n5. Chłodzenie i podanie:\nPozwól ciastkom chwilę ostygnąć, a następnie podawaj i ciesz się ich smakiem!\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
      "400 g mąki gryczanej (około 2 pełne szklanki)",
      "3 czubate łyżki mąki ziemniaczanej",
      "2 płaskie łyżeczki sody oczyszczonej",
      "4 płaskie łyżki kakao",
      "250 g płynnego miodu",
      "100 g oleju kokosowego",
      "1 pełna łyżka cynamonu",
      "1 płaska łyżeczka goździków mielonych",
      "1 płaska łyżeczka kardamonu mielonego"
  ].join("\n"),
  "path": "ciastka"
},



{
  "id": "ciastko-3",
  "name": "Ciastka owsiane z 3 składników",
  "category": "CIASTKA",
  "shortDesc": "Trochę jak ciastka, trochę jak pankejki",
  "fullDesc": "Te zdrowe ciastka owsiane z 3 składników to szybki i łatwy sposób na domową przekąskę bez zbędnych dodatków. Po upieczeniu przypominają trochę pankejki z piekarnika, ponieważ są miękkie i delikatne. Idealne jako zdrowa alternatywa dla klasycznych ciastek!",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Przygotowanie ciasta:\nBanany obierz ze skórki i rozgnieć widelcem na papkę w misce. Dodaj masło orzechowe i dokładnie wymieszaj. Wsyp płatki owsiane oraz ewentualne dodatki, takie jak rodzynki lub miód. Całość wymieszaj łyżką, aż powstanie jednolita masa.\n\n2. Rozgrzanie piekarnika:\nNastaw piekarnik na 180°C. Wyłóż blachę papierem do pieczenia.\n\n3. Formowanie ciasteczek:\nŁyżką nakładaj porcje ciasta na blachę. Wygładź i spłaszcz każdą porcję małą łyżeczką, aby uzyskać okrągły kształt.\n\n4. Pieczenie:\nPiecz ciastka przez 12-15 minut, aż staną się suche i lekko rumiane.\n\n5. Chłodzenie i podanie:\nPozwól ciasteczkom ostygnąć przed ściąganiem z blaszki. Podawaj i ciesz się ich naturalnym smakiem!\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "2 dojrzałe banany",
    "2 łyżki masła orzechowego (np. migdałowego, z nerkowców lub słonecznika)",
    "150 g płatków owsianych bezglutenowej",
    "Opcjonalnie: Garść rodzynek",
    "Opcjonalnie: 1 łyżka miodu",
  ].join("\n"),
  "path": "ciastka-owsiane-3-skladniki"
},


{
  "id": "ciastko-4",
  "name": "Kruche ciasteczka",
  "category": "CIASTKA",
  "shortDesc": "Ambitne w wykonaniu kruche ciasteczka",
  "fullDesc": "Te kruche ciasteczka to szybki i prosty sposób na pyszną przekąskę, ale wymagają sporo cierpliwości. Masa jest sucha i krusząca się, co czyni je prawdziwym wyzwaniem. To przepis dla desperatów, którzy naprawdę chcą poczuć satysfakcję z własnoręcznie wykonanych ciastek.",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Przygotowanie ciasta:\nPosiekaj wszystkie składniki (uniwersalną mieszankę mąk bezglutenowych, jajko, ksylitol i olej kokosowy) i szybko zagnieć jednolite ciasto. Jeśli chcesz, dodaj posiekane orzechy.\n\n2. Formowanie ciastek:\nRozwałkuj ciasto na lekko posypanej mąką (uniwersalną mieszanką mąk bezglutenowych) powierzchni i wykrawaj dowolne kształty foremkami do ciastek.\n\n3. Pieczenie:\nNagrzej piekarnik do 180°C. Piecz ciasteczka przez kilka minut, aż nabiorą lekko złotego koloru.\n\n5. Chłodzenie i podanie:\nPozwól ciasteczkom ostygnąć przed podaniem.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "1 szklanka uniwersalnej mieszanki mąk bezglutenowych {LINK}",
    "1 jajko",
    "¼ szklanki ksylitolu (lub cukru trzcinowego)",
    "10 dag oleju kokosowego",
    "Opcjonalnie: posiekane orzechy"
  ],
  "path": "ciastka"
},




{
  "id": "ciastko-5",
  "name": "Pieguski",
  "category": "CIASTKA",
  "shortDesc": "Pyszne z migdałową mąką i gorzką czekoladą",
  "fullDesc": "Pieguski to wyjątkowe ciasteczka, które łączą w sobie smak migdałowej mąki i gorzkiej czekolady. Idealne dla miłośników słodkości bez pszenicy i glutenu. Ich przygotowanie to czysta przyjemność! Przepis pochodzi z 'Kuchni bez Pszenicy' Williama Davies'a.",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 180°C. Blachę wyłóż papierem do pieczenia.\n\n2. Mieszanie składników suchych:\nW misce wymieszaj mąkę migdałową, sodę oczyszczoną i sól.\n\n3. Przygotowanie składników mokrych:\nW osobnej misce utrzyj jajka, olej kokosowy i mleko kokosowe. Następnie połącz je z suchymi składnikami.\n\n4. Dodawanie czekolady:\nDo ciasta dodaj posiekaną gorzką czekoladę i dokładnie wymieszaj.\n\n5. Formowanie ciasteczek:\nZa pomocą łyżki nakładaj spore porcje ciasta na blaszkę. Spłaszcz każde ciastko na grubość około 12 mm.\n\n6. Pieczenie:\nPiecz ciasteczka przez 25 minut, aż brzegi lekko zbrązowieją.\n\n7. Chłodzenie i podanie:\nPozwól ciasteczkom ostygnąć przed podaniem.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "4 szklanki mąki migdałowej",
    "1 łyżeczka sody oczyszczonej",
    "½ łyżeczki soli",
    "4 jajka",
    "½ szklanki roztopionego oleju kokosowego",
    "¼ szklanki mleka kokosowego",
    "½ płynnego słodzika",
    "285 g posiekanej gorzkiej czekolady"
  ],
  "path": "ciastka"
},



{
  "id": "ciastko-6",
  "name": "Ciastka migdałowo-owsiane",
  "category": "CIASTKA",
  "shortDesc": "Pyszne, zdrowe ciastka z migdałami, płatkami owsianymi i bakaliami.",
  "fullDesc": "Ciastka migdałowo-owsiane to pyszna przekąska pełna zdrowych składników, takich jak migdały, płatki owsiane, wiórki kokosowe i bakalia. Idealne na każdą okazję, a ich przygotowanie jest szybkie i łatwe!",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 150°C.\n\n2. Przygotowanie suchych składników:\nDo miski wsyp mąkę migdałową, mąkę bezglutenową i sodę oczyszczoną. Wymieszaj.\n\n3. Dodanie pozostałych składników:\nDodaj płatki owsiane, wiórki kokosowe oraz mieszankę bakalii (rodzynki, żurawina, goji, aronia). Wymieszaj.\n\n4. Roztopienie masła:\nW rondelku roztop olej kokosowy z miodem i 1 łyżką wody.\n\n5. Łączenie składników:\nPrzelej roztopioną mieszankę do miski z sypkimi składnikami. Wymieszaj, a następnie dodaj jajko (jeśli używasz).\n\n6. Formowanie ciastek:\nZ powstałej masy, mokrymi rękami ulepi kulki o średnicy ok. 3 cm. Następnie spłaszcz je, formując dyski o średnicy 4 cm i grubości 1,5 cm. Ułóż na blasze wyłożonej papierem do pieczenia, zachowując odstępy.\n\n7. Pieczenie:\nWstaw ciastka do piekarnika i piecz przez 15 minut, aż staną się złociste. Ciastka będą miękkie po wyjęciu, ale stwardnieją podczas studzenia.\n\n8. Chłodzenie i podanie:\nPozwól ciastkom ostygnąć przed podaniem.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "3/4 szklanki mąki migdałowej",
    "1/2 szklanki mąki bezglutenowej",
    "1/2 łyżeczki sody oczyszczonej",
    "1 szklanka płatków owsianych bezglutenowych",
    "1/2 szklanki wiórków kokosowych",
    "około 80 g mieszanki rodzynek, suszonej żurawiny, goji i aroni",
    "125 g oleju kokosowego",
    "3 łyżki miodu",
    "Opcjonalnie: 1 jajko"
  ],
  "path": "ciastka"
},


{
  "id": "ciastko-7",
  "name": "Ciastka amaretti",
  "category": "CIASTKA",
  "shortDesc": "Delikatne ciastka amaretti z migdałową nutą",
  "fullDesc": "Ciastka amaretti to klasyczna włoska przekąska o migdałowym smaku, która zachwyca swoją prostotą i delikatnością. Idealne dla miłośników słodkości bezglutenowych.",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Przygotowanie piekarnika:\nRozgrzej piekarnik do 180°C.\n\n2. Przygotowanie białek:\nUbij białka na sztywno.\n\n3. Łączenie składników:\nDo dużej miski wrzuć mąkę migdałową i cukier puder, następnie dodaj ubite białka i dokładnie wymieszaj.\n\n4. Formowanie ciastek:\nZwilżonymi rękami formuj kulki wielkości orzecha włoskiego, delikatnie je spłaszcz i układaj na blasze wyłożonej papierem do pieczenia.\n\n5. Pieczenie:\nPiec ciastka przez 15-20 minut, aż staną się złoto-brązowe. Ciastka podwajają objętość.\n\n6. Chłodzenie:\nOstudź ciastka przed podaniem.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "200 g mąki migdałowej",
    "150 g cukru pudru",
    "2 białka"
  ],
  "path": "ciastka"
},



{
  "id": "ciastko-8",
  "name": "Bezy klasyczne",
  "category": "CIASTKA",
  "shortDesc": "Lekkie i chrupiące, idealne na deser",
  "fullDesc": "Bezy to klasyczny deser, który zachwyca swoją lekkością i słodyczą. Choć oczywiście są dość słodkie i nie stanowią idealnej opcji, jeśli chodzi o zdrowie, to dla dziecka, które nie może jeść tradycyjnych ciast czy tortów, na przykład na urodzinach, są prawdziwą przyjemnością. Wciąż stanowią stosunkowo zdrowszą alternatywę w porównaniu do sklepowych słodyczy pełnych dziwnych dodatków. To wybór, który pozwala cieszyć się wyjątkowym smakiem, nie rezygnując z troski o zdrowie.",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Przygotowanie białek:\nOddziel białka od żółtek, upewnij się, że w białkach nie ma najmniejszych śladów żółtka. Białka umieść w czystym, suchym naczyniu.\n\n2. Ubicie białek:\nDodaj szczyptę soli i zacznij ubijać białka mikserem na mniejszych obrotach, stopniowo zwiększając prędkość. Ubijać przez 2-3 minuty.\n\n3. Dodawanie cukru:\nStopniowo dodawaj cukier, po każdej łyżce miksuj białka na najwyższych obrotach przez około minutę. Kontynuuj ubijanie, aż powstanie gładka, błyszcząca masa.\n\n4. Przygotowanie do pieczenia:\nPrzełóż masę do rękawa cukierniczego i formuj mini beziki na blasze wyłożonej papierem do pieczenia.\n\n5. Pieczenie:\nPiekarnik nagrzej do 100°C opcja grzania: góra/dół. Piecz beziki przez 90 minut, nie zmieniając temperatury. Po zakończeniu pieczenia, uchyl drzwiczki piekarnika i pozwól bezom wystygnąć w środku.\n\n6. Studzenie:\nPo wystudzeniu zdejmij bezy z papieru i pozostaw na kratce przez kilka minut, aby całkowicie ostygły.\n\nUwaga:\n Zamiast cukru można użyć ksylitolu. Sprawdź przepis bezy na ksylitolu {LINK}.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "2 białka średnich jajek, mocno schłodzonych",
    "⅓ szklanki cukru",
    "Szczypta soli himalajskiej lub innej wysokiej jakości"
  ],
  "path": "ciastka"
},


{
  "id": "ciastko-9",
  "name": "Bezy z ksylitolem",
  "category": "CIASTKA",
  "shortDesc": "Delikatne bezy bez cukru",
  "fullDesc": "Bezy z ksylitolem to alternatywa dla tradycyjnych bez cukru. Choć mają nieco inną konsystencję i smak, stanowią doskonałą opcję dla osób, które chcą uniknąć cukru. Te bezy są lekkie, chrupiące i wciąż pyszne, a dzięki ksylitolowi są bardziej przyjazne dla zdrowia, zachowując jednocześnie wyjątkowy smak.",
  "image": "Ciastka/ciastko.jpg",
  "preparation": "1. Ubijanie białek:\n W misce ubij białka ze szczyptą soli na sztywną pianę.\n\n2. Dodawanie ksylitolu:\nStopniowo, łyżka po łyżce, dodawaj zmielony ksylitol, kontynuując ubijanie na najwyższych obrotach, aż masa stanie się gładka i błyszcząca.\n\n3. Dodanie mąki ziemniaczanej:\nPrzesiej mąkę ziemniaczaną nad pianą i delikatnie wymieszaj szpatułką, aby nie zniszczyć struktury piany.\n\n4.Formowanie bez:\nPrzełóż masę do rękawa cukierniczego i wyciskaj na blaszkę wyłożoną papierem do pieczenia małe porcje w kształcie okrągłych bezików, albo nakładaj masę zgrabnie łyżką.\n\n5. Pieczenie:\nPiecz w piekarniku nagrzanym do 130°C przez około 45 minut, a następnie zmniejsz temperaturę do 80°C i susz bezy przez kolejne 2 godziny.\n\n6. Studzenie:\nPo upieczeniu pozostaw bezy w piekarniku z uchylonymi drzwiczkami do całkowitego wystudzenia.\n\nUwaga:\nBezy z ksylitolem mogą mieć nieco inną konsystencję i smak niż tradycyjne bezy z cukrem, ale są doskonałą alternatywą dla osób unikających cukru.\n\n\nZdrowego! 🌱✨💚",
  "ingredients": [
    "5 białek jajek, mocno schłodzonych",
    "300 g zmielonego ksylitolu",
    "1 łyżka mąki ziemniaczanej",
    "Szczypta soli himalajskiej lub innej wysokiej jakości"
  ],
  "path": "ciastka"
},

















]

export default Ciastka;
